import React from "react";
import { WifiOff } from "lucide-react";

export const LoadError = ({ onRetry }) => (
  <div className="heritage-card p-8 text-center text-[#6E5B4F] max-w-xl mx-auto my-10" data-testid="load-error">
    <WifiOff className="w-8 h-8 mx-auto text-[#993D22] mb-3" />
    <p className="font-serif-heritage text-xl text-[#261911] mb-2">Le chargement a échoué</p>
    <p className="text-sm mb-4">La connexion est lente ou interrompue. Vérifiez votre réseau puis réessayez.</p>
    <button type="button" onClick={onRetry} className="btn-terra text-sm" data-testid="load-error-retry">Réessayer</button>
  </div>
);

export default LoadError;
